import React from 'react';
import { HeartIcon, MenuIcon, SignalHighIcon, WifiIcon, BatteryFullIcon } from 'lucide-react';
import { brokerage, listing, agent } from '../../../data/reportPhilly';
// A clean recreation of the Fox & Roach listing detail page as it appears on
// mobile, framed in a phone.
export function PhoneListing() {
  return <div className="w-[190px] shrink-0 overflow-hidden rounded-[2rem] border-[6px] border-[#1a1a1a] bg-black shadow-2xl sm:w-[210px]" data-id="element-782" data-mp="1fu6j2s18qvzl">
      <div className="relative overflow-hidden rounded-[1.55rem] bg-white" data-id="element-783" data-mp="23gwlhuhi4skq">
        {/* status bar */}
        <div className="flex items-center justify-between bg-white px-4 pb-1 pt-2 text-[9px] font-semibold text-black" data-id="element-784" data-mp="28fpyllsvmhkd">
          <span data-id="element-785" data-mp="1yjmmbn4b92jp">9:41</span>
          <div className="flex items-center gap-1" data-id="element-786" data-mp="1yiv0h40imj6m">
            <SignalHighIcon className="size-3" data-id="element-787" data-mp="1ylqzkvo3ndwn" />
            <WifiIcon className="size-3" data-id="element-788" data-mp="j22vbjhqrc1f" />
            <BatteryFullIcon className="size-3.5" data-id="element-789" data-mp="j5ieaxejd584" />
          </div>
        </div>
        {/* notch */}
        <div className="pointer-events-none absolute left-1/2 top-1.5 h-4 w-20 -translate-x-1/2 rounded-full bg-black" data-id="element-790" data-mp="n2ehj0pr5kf0" />

        {/* mobile brand bar */}
        <div className="flex items-center justify-between border-b-2 border-bhhs-cab px-3 py-2" data-id="element-791" data-mp="1ygq0vuoap0tp">
          <img src={brokerage.logoLight} alt={brokerage.name} className="h-6 w-auto object-contain object-left" data-id="element-792" data-mp="2cg8yvune6vsa" />
          <MenuIcon className="size-4 text-bhhs-cab" data-id="element-793" data-mp="2md3ti2gjoc1a" />
        </div>

        {/* hero photo */}
        <div className="relative" data-id="element-794" data-mp="2heae24hp6ayh">
          <span className="absolute left-2 top-2 z-10 bg-white px-1.5 py-0.5 text-[8px] font-bold tracking-wide text-[#2a2a2a] shadow" data-id="element-795" data-mp="2hd9463cf3uic">
            NEW
          </span>
          <button className="absolute right-2 top-2 z-10 flex size-6 items-center justify-center rounded-full bg-white/90 text-bhhs-cab shadow" data-id="element-796" data-mp="2r4c4v41fq7h3">
            <HeartIcon className="size-3.5" data-id="element-797" data-mp="354ehaaqz48oy" />
          </button>
          <img src={listing.heroImage} alt={listing.address} className="h-32 w-full object-cover" data-id="element-798" data-mp="305a7bhw866xk" />
          <span className="absolute bottom-2 right-2 rounded bg-black/60 px-1.5 py-0.5 text-[8px] font-medium text-white" data-id="element-799" data-mp="1xt70t156zkfe">
            1 / 67
          </span>
        </div>

        {/* summary */}
        <div className="px-3 py-2.5 text-[#2a2a2a]" data-id="element-800" data-mp="26qr2ucavpkr2">
          <p className="text-lg font-bold leading-none text-[#1a1a1a]" data-id="element-801" data-mp="2bjairfx1grz1">
            {listing.price}
          </p>
          <h3 className="mt-1.5 text-[11px] font-bold uppercase leading-tight text-[#1a1a1a]" data-id="element-802" data-mp="2ggsg091p1ir7">
            {listing.address}
          </h3>
          <p className="text-[10px] font-medium uppercase text-[#4a4a4a]" data-id="element-803" data-mp="2lj1cvghot4yl">
            {listing.cityState}
          </p>
          <p className="mt-1 text-[9px] text-[#6a6a6a]" data-id="element-804" data-mp="2uhmp6twkfnqx">
            {listing.beds} Beds · {listing.baths} Baths · {listing.sqft} Sq. ft.
          </p>

          <div className="mt-2.5 grid grid-cols-2 gap-1.5" data-id="element-805" data-mp="w3bl4yl1sed1">
            <span className="bg-bhhs-cab py-1.5 text-center text-[8px] font-semibold text-white" data-id="element-806" data-mp="10329ywr0kkex">
              SCHEDULE SHOWING
            </span>
            <span className="border border-bhhs-cab py-1.5 text-center text-[8px] font-semibold text-bhhs-cab" data-id="element-807" data-mp="slnpeswwgxz8">
              REQUEST INFO
            </span>
          </div>

          {/* agent row */}
          <div className="mt-2.5 flex items-center gap-2 border-t border-border pt-2" data-id="element-808" data-mp="iuj8vorkt52a">
            <img src={agent.avatar} alt={agent.name} className="size-6 rounded-full object-cover" data-id="element-809" data-mp="eu93oeblyioh" />
            <div className="leading-tight" data-id="element-810" data-mp="16k3ukff46gf9">
              <p className="text-[9px] font-semibold text-bhhs-cab" data-id="element-811" data-mp="16kdkk305snky">
                {agent.name}
              </p>
              <p className="text-[8px] text-[#6a6a6a]" data-id="element-812" data-mp="12gfndxue9muj">{agent.phone}</p>
            </div>
          </div>
        </div>

        {/* home indicator */}
        <div className="flex justify-center pb-1.5 pt-0.5" data-id="element-813" data-mp="3n90ylurarp9k">
          <span className="h-1 w-16 rounded-full bg-black/70" data-id="element-814" data-mp="3n64xxyo2emhf" />
        </div>
      </div>
    </div>;
}